import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, subscribed: false, permission: "unsupported" };
  const permission = Notification.permission;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return { supported: true, subscribed: false, permission };
    const sub = await reg.pushManager.getSubscription();
    return { supported: true, subscribed: !!sub, permission };
  } catch {
    return { supported: true, subscribed: false, permission };
  }
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push not supported in this browser");
  const reg = await navigator.serviceWorker.register("/sw.js");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications blocked");
  const { data } = await api.get("/push/vapid-public-key");
  const key = urlBase64ToUint8Array(data.key);
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return true;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe();
  }
  return true;
}
